<div class="modal-unit {{ modal.classList }}" [style]="'max-width:' + modal.width + 'px;'">
  @if (modal.title) {
    <p class="title" [innerHTML]="modal.title"></p>
  }

  <button
    attr.aria-label="{{ 'modalItems.close' | cxTranslate }}"
    class="btn bg-transparent border-0 box-close"
    (click)="close()"
    data-testid="closeModal"
    >
    <modal-close size="12"></modal-close>
  </button>

  <div class="box-content">
    <ng-template #dynamicContainer></ng-template>
  </div>
</div>
